import * as actionTypes from './actionTypes';
import axios from 'axios';

export const caseinfo_success = (response) => {
    // console.log('action caseinfo_success: '+JSON.stringify(response))
    // console.log('action caseinfo_success2: '+response.data.name_of_lender)
    // console.log('action caseinfo_success2: '+response.data.claimantOffer)
    return({
        type: actionTypes.CASEINFO_SUCCESS,
        conversationId: response.data.conversationId,
        caseId: response.data.caseId,
        status: response.data.status,
        agreement_type: response.data.agreement_type,
        kind_of_claim: response.data.kind_of_claim,
        language: response.data.language,
        claimant_company_incorporation_location: response.data.lender_company_incorporation_location,
        claimant_email_address: response.data.lender_email_address,
        claimant_made_loan_as: response.data.lender_made_loan_as,
        claimant_registered_address: response.data.lender_registered_address,
        claimant_name: response.data.name_of_lender,
        claimant_hkid: response.data.lender_hkid,
        claimant_passport: response.data.lender_passport,
        claimant_registered_address: response.data.lender_registered_address,
        claimant_address: response.data.lender_address,
        agreement_oral_or_written: response.data.agreement_oral_or_written,
        respondent_email_address: response.data.borrower_email_address,
        respondent_incorporation_company_location: response.data.borrower_incorporation_company_location,
        respondent_person_or_company: response.data.borrower_person_or_company,
        respondent_telephone: response.data.borrower_telephone,
        dater_entering: response.data.dater_entering,
        interest_or_not: response.data.interest_or_not,
        claimant_telephone: response.data.lender_telephone,
        total_outstanding_loan: response.data.total_outstanding_loan,
        loan_payments: response.data.loan_payments,
        repayment_method: response.data.repayment_method,
        repayment_of_loan: response.data.repayment_of_loan,
        the_written_clause_amount_of_loan: response.data.the_written_clause_amount_of_loan,
        the_written_clause_rate_of_interest: response.data.the_written_clause_rate_of_interest,
        total_amount_of_loan: response.data.total_amount_of_loan,
        written_clause_term_of_repayment: response.data.written_clause_term_of_repayment,
        did_respondent_make_other_payment: response.data.did_respondent_make_other_payment,
        repeated_request: response.data.repeated_request,
        resolve_by: response.data.resolve_by,
        respondent_name: response.data.borrower_name,
        respondent_hkid: response.data.borrower_hkid,
        respondent_passport: response.data.borrower_passport,
        respondent_registered_address: response.data.borrower_registered_address,
        respondent_address: response.data.borrower_address,
        respondent_docs: response.data.respondent_docs,
        arbitrator_docs: response.data.arbitrator_docs,
        claimant_docs: response.data.claimant_docs,
        admin_docs: response.data.admin_docs,
        claimant_steps_completed: response.data.claimant_steps_completed,
        respondent_steps_completed: response.data.respondent_steps_completed,
        finished: response.data.finished,
        respondent_newAccount: response.data.respondent_newAccount,
        claimant_newAccount: response.data.claimant_newAccount,
        claimantUniqueId: response.data.claimantUniqueId,
        respondentUniqueId: response.data.respondentUniqueId,
        claimantOfferStatus: response.data.claimantOfferStatus,
        claimantOffer: response.data.claimantOffer,
        respondentOfferStatus: response.data.respondentOfferStatus,
        respondentOffer: response.data.respondentOffer,
        acceptedOffer: response.data.acceptedOffer,
        claimantPayment: response.data.claimant_payment,
        respondentPayment: response.data.respondent_payment,
        award: response.data.award,
        claimantArbitratorName: response.data.claimantArbitratorName,
        respondentArbitratorName: response.data.respondentArbitratorName,
        caseData: response.data

    });
}

export const caseinfo_fail = (error) => {
    return({
        type: actionTypes.CASEINFO_FAIL,
        error: error
    });
}

export const scheduleMeetingFail = () => {
    return({
        type: actionTypes.SCHEDULE_MEETING_FAIL,
        error: true
    });
}

export const scheduleMeetingTrue = () => {
    return({
        type: actionTypes.SCHEDULE_MEETING_TRUE,
        error: false
    });
}


export const caseinfo_start = () => {
    return({
        type: actionTypes.CASEINFO_START,
    });
}

export const setCaseInformationUserType = (userType) => {
    return({
        type: actionTypes.SET_CASE_INFORMATION_USERTYPE,
        userType: userType,
    });
}

export const setAddOfferError = () => {
    return({
        type: actionTypes.SET_ADD_OFFER_ERROR,
        AddOfferError: true,
    });
}

export const setAddOfferNoError = () => {
    return({
        type: actionTypes.SET_ADD_OFFER_NOERROR,
        AddOfferError: false,
    });
}

export const setAddOfferAccepted = () => {
    return({
        type: actionTypes.SET_ADD_OFFER_ACCEPTED,
        AddOfferAccepted: true,
        AddOfferError: false,

    });
}

export const changeResponseToReEnter = (caseId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/changeResponseToReEnter`;
    
    const getCaseInfoData = {
        caseId: caseId
    };

    return (dispatch) => {
        dispatch(caseinfo_start());
        axios.post(url, {
            ...getCaseInfoData
        })
        .then((response) => {
            console.log('changeResponseToReEnter: '+JSON.stringify(response) )
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            let uniqueId = localStorage.getItem('token');
            dispatch(getCaseInfo(caseId, uniqueId));
        })
    };

}

export const getCaseInfo = (caseId, uniqueId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getCaseInfo`;
    console.log(`** getCaseInfo ${caseId}`)
    const getCaseInfoData = {
        caseId: caseId
    };
    return (dispatch) => {
        dispatch(caseinfo_start());
        console.log('loading case Info now')
        axios.post(url, {
            ...getCaseInfoData
        })
        .then((response) => {
            console.log('DFM response')
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            let userType = null;
            let uniqueId = localStorage.getItem('token');
            console.log(`the uniqueId is : ${uniqueId}`)
            // console.log('caseInfo determining userType: response.data.claimantUniqueId: '+response.data.claimantUniqueId)
            // console.log('caseInfo determining userType: response.data.respondentUniqueId: '+response.data.respondentUniqueId)
            console.log('caseInfo determining userType: uniqueId: '+uniqueId)
            console.log(response.data)
            if(response.data.claimantUniqueId == uniqueId){
                userType = 'claimant';
            }else if(response.data.respondentUniqueId == uniqueId){
                userType = 'respondent';
            }
            else if (response.data.uniqueId == uniqueId){
                userType = 'arbitrator'
            }
            console.log('the userType being set is##: '+userType);
            dispatch(setCaseInformationUserType(userType));
            dispatch(caseinfo_success(response));
        })
        // .catch((error) => {
        //     dispatch(caseinfo_fail(error));
        // });
    };

}

export const changeNoOfDays = (caseId, NoOfdays, uniqueId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/changeDateForFurtherProceedings`;
    
    const setChangeNoOfDays = {
        caseId: caseId,
        addNoOfDays: NoOfdays
    };
    console.log('setChangeNoOfDays: '+JSON.stringify(setChangeNoOfDays))

    return (dispatch) => {
        axios.post(url, {
            ...setChangeNoOfDays
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            dispatch(getCaseInfo(caseId, uniqueId));
        })
    };

}

export const setRelease = (caseId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/setRelease`;
    
    const setReleaseData = {
        caseId: caseId
    };

    // const setReleaseData = {
    //     caseId: 3,
    // };

    return (dispatch) => {
        dispatch(caseinfo_start());
        axios.post(url, {
            ...setReleaseData
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                throw (`login ${response.data}`);
            }
            let uniqueId = localStorage.getItem('token');
            dispatch(getCaseInfo(caseId, uniqueId));
            // let userType = null;
            // let uniqueId = localStorage.getItem('token');
            // console.log('setRelease determining userType: response.data.claimantUniqueId: '+response.data.claimantUniqueId)
            // console.log('setRelease determining userType: response.data.respondentUniqueId: '+response.data.respondentUniqueId)
            // console.log('setRelease determining userType: uniqueId: '+uniqueId)
            // if(response.data.claimantUniqueId == uniqueId){
            //     userType = 'claimant';
            // }else if(response.data.respondentUniqueId == uniqueId){
            //     userType = 'respondent';
            // }
            // console.log('the userType being set is: '+userType);
            // dispatch(setRelease_success(response));
        })
        // .catch((error) => {
        //     dispatch(setRelease_fail(error));
        // });
    };

}

export const setOffer = (caseId, userType, offer, uniqueId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/AddOffer`;
    
    const setOffer = {
        caseId: caseId,
        userType: userType,
        offer: offer
    };

    console.log('setOffer params: '+JSON.stringify(setOffer));

    return (dispatch) => {
        axios.post(url, {
            ...setOffer
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                dispatch(setAddOfferError());
            }

            if (response.data == 'saved'){
                dispatch(getCaseInfo(caseId, uniqueId));
                dispatch(setAddOfferNoError());
            }

            if (response.data == 'offerAcceptedAlready'){
                dispatch(setAddOfferAccepted());
            }


            // if(userType == 'claimant'){
            //     if (response.data == 'offerAcceptedAlready'){
            //         dispatch(claimantOffer(response));
            //     }
            //     else if (response.data == 'saved'){
            //         dispatch(caseinfo_success(response));
            //     }
            //     else if (response.data == 'saved'){
            //         dispatch(caseinfo_success(response));
            //     }
            // }
            // else if (userType == 'respondent'){
            //     if (response.data == 'offerAcceptedAlready'){
            //         dispatch(caseinfo_success(response));
            //     }
            //     else if (response.data == 'saved'){
            //         dispatch(caseinfo_success(response));
            //     }
            //     else if (response.data == 'saved'){
            //         dispatch(caseinfo_success(response));
            //     }
            // }
        })
        // .catch((error) => {
        //     dispatch(caseinfo_fail(error));
        // });
    };

}

export const setAcceptOffer = (caseId, userType, offer, uniqueId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/AddAcceptOffer`;
    
    const setOffer = {
        caseId: caseId,
        userType: userType,
        offer: offer
    };

    return (dispatch) => {
        axios.post(url, {
            ...setOffer
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                dispatch(setAddOfferError());
            }

            if (response.data == 'saved'){
                dispatch(getCaseInfo(caseId, uniqueId));
            }
        })
    };
}

export const setRefuseOffer = (caseId, userType, offer, uniqueId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/AddRefuseOffer`;
    
    const setOffer = {
        caseId: caseId,
        userType: userType,
        offer: offer
    };

    return (dispatch) => {
        axios.post(url, {
            ...setOffer
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                dispatch(setAddOfferError());
            }

            if (response.data == 'saved'){
                dispatch(getCaseInfo(caseId, uniqueId));
            }
        })
    };
}

export const scheduleMeeting = (caseId, dateTimeForShow, dateTime, audioOnly) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/newmeeting`;
    
    const scheduleMeetingData = {
        caseId: caseId,
        dateTimeForShow: dateTimeForShow,
        dateTime: dateTime,
        audioOnly:audioOnly
    };

    console.log('scheduleMeetingData params: '+JSON.stringify(scheduleMeetingData));

    return (dispatch) => {
        axios.post(url, {
            ...scheduleMeetingData
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error'){
                dispatch(scheduleMeetingFail());
            }

            if (response.data == 'scheduled'){
                dispatch(scheduleMeetingTrue());
                dispatch(getCaseInfo(caseId, ''));
            }

        })
    };

}

export const removeScheduleMeeting = (caseId) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/removeMeeting`;
    
    const scheduleMeetingData = {
        caseId: caseId,
    };

    console.log('scheduleMeetingData params: '+JSON.stringify(scheduleMeetingData));

    return (dispatch) => {
        axios.post(url, {
            ...scheduleMeetingData
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error'){
                // dispatch(scheduleMeetingFail());
            }

            if (response.data == 'removed'){
                dispatch(getCaseInfo(caseId, ''));
            }

        })
    };

}